import { Chip, Typography, useTheme } from '@material-ui/core'
import React from 'react'
import AnonymousModeIcon from './AnonymousModeIcon'

export default function AnonymousMode({ isMobile }) {
  const theme = useTheme()
  return (
    <div style={{ display: 'flex', alignItems: 'center', margin: 10, cursor: 'pointer' }}>
      {!isMobile && (
        <Chip
          size="small"
          label={<Typography variant="button">modo anônimo</Typography>}
          style={{ background: theme.palette.background.default, marginRight: 10 }}
        />
      )}
      <AnonymousModeIcon style={{ fontSize: 44 }} />
    </div>
  )
}
